import { render } from "./success.vue?vue&type=template&id=0ba8eb4a&scoped=true"
import script from "./success.vue?vue&type=script&lang=js"
export * from "./success.vue?vue&type=script&lang=js"

import "./success.vue?vue&type=style&index=0&id=0ba8eb4a&scoped=true&lang=css"

import exportComponent from "/data/jenkins_home/workspace/prod-AI-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ba8eb4a"]])

export default __exports__